import { render, staticRenderFns } from "./ArchiveSettingsModal.vue?vue&type=template&id=08137f4c"
import script from "./ArchiveSettingsModal.vue?vue&type=script&lang=js"
export * from "./ArchiveSettingsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports